import { Product } from '../types/product'

export const categoryLabels: Record<string, string> = {
  laine: 'Pelotes de laine',
  crochet: 'Créations au crochet',
  mercerie: 'Mercerie & fils',
  puzzle: 'Puzzles',
}

export const products: Product[] = [
  {
    slug: 'comfort-6',
    name: 'Comfort 6',
    category: 'laine',
    tagline: 'Une laine douce, moelleuse et facile à tricoter',
    description:
      "La valeur sûre de l'atelier : une pelote épaisse de 100 g qui monte vite aux aiguilles 6 mm. Idéale pour les plaids, les gros pulls d'hiver, les snoods et toute la décoration en grosses mailles.",
    image:
      'https://cdn.magicpatterns.com/uploads/1bKHCphVDenESK6QAgBJq9/brk-3ae9845c-1bc1-438a-8012-fe72240d9c4f.jpg',
    price: 2.95,
    unit: 'la pelote de 100 g',
    oekotex: true,
    stock: 'en-stock',
    featured: true,
    specs: [
      { label: 'Poids', value: 'Pelote de 100 g' },
      { label: 'Aiguilles', value: '6 – 6,5 mm' },
      { label: 'Composition', value: '75 % acrylique · 25 % laine' },
      { label: 'Entretien', value: 'Lavage machine 30°' },
    ],
    colorways: [
      { code: '520', name: 'Moutarde', hex: '#D89218' },
      { code: '791', name: 'Gris clair', hex: '#B9B0A6' },
      { code: '015', name: 'Beige', hex: '#C9A077' },
      { code: '016', name: 'Écru', hex: '#EFE6D2' },
      { code: '005', name: 'Gris', hex: '#A8AAAC' },
      { code: '071', name: 'Vert', hex: '#5C8268' },
      { code: '792', name: 'Taupe', hex: '#8C7A6E' },
      { code: '072', name: 'Émeraude', hex: '#0E5744' },
      { code: '890', name: 'Marine', hex: '#23304F' },
      { code: '039', name: 'Bleu roi', hex: '#1741A6' },
      { code: '456', name: 'Bleu ciel', hex: '#7FC4CE' },
      { code: '710', name: 'Rose', hex: '#EFA9B4' },
      { code: '043', name: 'Rouge', hex: '#C4132C' },
      { code: '042', name: 'Bordeaux', hex: '#8A1230' },
      { code: '714', name: 'Prune', hex: '#7E3355' },
      { code: '110', name: 'Chocolat', hex: '#4E3229' },
    ],
  },
  {
    slug: 'jo-metal',
    name: 'Jo Métal',
    category: 'laine',
    tagline: 'Une touche de brillance à vos créations',
    description:
      "Un fil chenille rehaussé d'un filament métallisé qui accroche la lumière. Parfait pour les écharpes de fête, les bonnets et les accessoires que l'on veut voir briller.",
    image:
      'https://cdn.magicpatterns.com/uploads/qBeL4tH22UmsP7ZZxE1jx5/brk-6658cfa0-7659-460c-9ce4-94a9f6f4593e.jpg',
    price: 2.95,
    unit: 'la pelote de 50 g',
    oekotex: true,
    stock: 'en-stock',
    featured: true,
    specs: [
      { label: 'Poids', value: 'Pelote de 50 g' },
      { label: 'Aiguilles', value: '6 – 6,5 mm' },
      { label: 'Composition', value: '97 % acrylique · 3 % métallisé' },
      { label: 'Entretien', value: 'Lavage à la main conseillé' },
    ],
    colorways: [
      { code: '1521.01', name: 'Noir', hex: '#1A1A1A' },
      { code: '1521.02', name: 'Blanc', hex: '#F4F1EC' },
      { code: '1521.03', name: 'Écru', hex: '#E8DCC4' },
      { code: '1521.04', name: 'Taupe', hex: '#7D6C5D' },
      { code: '1521.07', name: 'Bleu jean', hex: '#3A6E8F' },
      { code: '1521.08', name: 'Rose', hex: '#F48FA3' },
      { code: '1521.09', name: 'Fuchsia', hex: '#D4106E' },
      { code: '1521.10', name: 'Rouge', hex: '#D6202A' },
      { code: '1521.11', name: 'Framboise', hex: '#A81351' },
      { code: '1521.13', name: "Vert d'eau", hex: '#79B99C' },
      { code: '1521.14', name: 'Bleu ciel', hex: '#5FB6E3' },
      { code: '1521.15', name: 'Bleu roi', hex: '#1540A8' },
      { code: '1521.16', name: 'Vert anis', hex: '#A8C22B' },
      { code: '1521.17', name: 'Kaki', hex: '#6F6B3C' },
      { code: '1521.20', name: 'Moutarde', hex: '#D79A15' },
      { code: '1521.21', name: 'Bordeaux', hex: '#7E1230' },
      { code: '1521.22', name: 'Chocolat', hex: '#4A3026' },
      { code: '1521.23', name: 'Gris', hex: '#9DA0A2' },
      { code: '1521.24', name: 'Violet', hex: '#7C4BB8' },
      { code: '1521.25', name: 'Parme', hex: '#B79AC4' },
    ],
  },
  {
    slug: 'footing',
    name: 'Footing',
    category: 'laine',
    tagline: 'Résistante, légère et agréable à tricoter',
    description:
      "Notre laine du quotidien, disponible en 24 coloris dont de très jolis chinés. Pulls, écharpes, gilets, accessoires : elle encaisse tous les projets et se lave sans broncher.",
    image:
      'https://cdn.magicpatterns.com/uploads/a4gyCVd2RZXdmgHwndqADu/brk-d5d15032-dc9d-4c44-8499-bfb6af203d0a.jpg',
    price: 1.9,
    unit: 'la pelote de 100 g',
    stock: 'en-stock',
    featured: true,
    options: [
      { id: 'pelote', label: 'À la pelote (100 g)', price: 1.9 },
      { id: 'paquet', label: 'Paquet de 8 pelotes', price: 15 },
    ],
    specs: [
      { label: 'Poids', value: 'Pelote de 100 g' },
      { label: 'Aiguilles', value: '6,5 – 7 mm' },
      { label: 'Composition', value: '100 % acrylique' },
      { label: 'Idéale pour', value: 'Pulls, écharpes, gilets' },
    ],
    colorways: [
      { code: '645', name: 'Beige chiné', hex: '#B08D6A' },
      { code: '063', name: 'Gris chiné', hex: '#AEB4BC' },
      { code: '064', name: 'Noir et blanc chiné', hex: '#3C3C3C' },
      { code: '645b', name: 'Gris clair', hex: '#C6CBD1' },
      { code: '110', name: 'Gris anthracite', hex: '#4A4E52' },
      { code: '062', name: 'Marron', hex: '#5B3520' },
      { code: '061', name: 'Bleu', hex: '#3F74BE' },
      { code: '060', name: 'Bordeaux', hex: '#7C0E22' },
      { code: '001', name: 'Écru', hex: '#EFE8D8' },
      { code: '013', name: 'Rouge', hex: '#D1101C' },
      { code: '011', name: 'Bleu marine', hex: '#16305E' },
      { code: '002', name: 'Noir', hex: '#161616' },
      { code: '006', name: 'Lilas', hex: '#9B79D4' },
      { code: '019', name: 'Vert', hex: '#0B7A3B' },
      { code: '017', name: 'Rose', hex: '#EE85A4' },
      { code: '018', name: 'Orange', hex: '#F05A14' },
      { code: '005', name: 'Jaune', hex: '#F5C310' },
      { code: '020', name: 'Turquoise', hex: '#2FBFC4' },
      { code: '015', name: 'Rose pâle', hex: '#EDA894' },
      { code: '016', name: 'Fuchsia', hex: '#E10D5E' },
      { code: '012', name: 'Bleu canard', hex: '#1B5468' },
      { code: '014', name: 'Kaki', hex: '#5E5F33' },
      { code: '021', name: 'Denim', hex: '#4A76A0' },
      { code: '022', name: 'Lavande', hex: '#A98BD6' },
    ],
  },
  {
    slug: 'canada',
    name: 'Canada',
    category: 'laine',
    tagline: 'Douce, chaude et idéale pour tous vos ouvrages',
    description:
      "Un mélange laine et acrylique qui tient chaud sans gratter, travaillé en aiguilles fines. Disponible à la pelote ou en paquet de 10 pour les grands projets.",
    image:
      'https://cdn.magicpatterns.com/uploads/jvF1jgiRP9Z97fZ1QkwQ1G/brk-d5f36e6e-6978-456f-a1c4-9e33cbeabdcc.jpg',
    price: 2.4,
    unit: 'la pelote de 50 g',
    stock: 'en-stock',
    options: [
      { id: 'pelote', label: 'À la pelote (50 g)', price: 2.4 },
      { id: 'paquet', label: 'Paquet de 10 pelotes', price: 20 },
    ],
    specs: [
      { label: 'Poids', value: 'Pelote de 50 g' },
      { label: 'Aiguilles', value: '4 – 4,5 mm' },
      { label: 'Composition', value: '60 % acrylique · 40 % laine' },
      { label: 'Conditionnement', value: 'Paquet de 10 × 50 g' },
    ],
    colorways: [
      { name: 'Rouge', hex: '#D0121F' },
      { name: 'Gris', hex: '#8E9193' },
      { name: 'Moutarde', hex: '#E0A011' },
      { name: 'Bleu marine', hex: '#122B57' },
      { name: 'Bleu turquoise', hex: '#3EBDD1' },
      { name: 'Rose', hex: '#EE6C9E' },
      { name: 'Vieux rose', hex: '#C97E95' },
      { name: 'Beige', hex: '#E3C7A6' },
      { name: 'Taupe', hex: '#7E7268' },
      { name: 'Noir', hex: '#141414' },
      { name: 'Parme', hex: '#B274D6' },
      { name: 'Lilas', hex: '#C79BE0' },
      { name: 'Bleu ciel', hex: '#49A9E8' },
      { name: 'Azur', hex: '#159FD4' },
      { name: 'Vert', hex: '#159447' },
    ],
  },
  {
    slug: 'azurite-pack-10',
    name: 'Azurite — Pack de 10',
    category: 'mercerie',
    tagline: 'Écheveaux de fils à broder, 10 pelotes de 50 g',
    description:
      "Le pack idéal pour la broderie, le point de croix et les petits accessoires : dix pelotes de 50 g aux teintes éclatantes, douces et faciles à travailler.",
    image:
      'https://cdn.magicpatterns.com/uploads/uLzanqV8KRK3vypbPdDbHE/brk-fd99fc47-1ae9-4926-966b-a952e09b4deb.jpg',
    price: 10,
    unit: 'le paquet de 10 pelotes',
    stock: 'en-stock',
    featured: true,
    specs: [
      { label: 'Contenu', value: '10 pelotes de 50 g' },
      { label: 'Composition', value: '100 % acrylique' },
      { label: 'Usages', value: 'Broderie, point de croix, kits' },
      { label: 'Palette', value: 'Assortiment de teintes vives' },
    ],
  },
  {
    slug: 'ourson-bonnet-mouton',
    name: 'Ourson au bonnet mouton',
    category: 'crochet',
    tagline: 'Doudou crocheté main, 32 cm',
    description:
      "Entièrement crocheté à la main dans l'atelier de Vouziers, cet ourson au bonnet mouton demande près de douze heures de travail. Rembourrage hypoallergénique, yeux sécurité cousus : il peut rejoindre un berceau sans crainte.",
    image:
      'https://cdn.magicpatterns.com/uploads/uRdNg3qPrBRn2PBfHG5pua/brk-9a3d0559-edea-440a-893a-ac2a5d89ca87.jpg',
    price: 38,
    unit: 'la pièce',
    stock: 'dernieres-pieces',
    featured: true,
    specs: [
      { label: 'Hauteur', value: 'Environ 32 cm' },
      { label: 'Matière', value: 'Fil acrylique doux' },
      { label: 'Fabrication', value: 'Pièce unique faite main' },
      { label: 'Entretien', value: 'Lavage à la main, 30°' },
    ],
  },
  {
    slug: 'elephant-salopette',
    name: 'Éléphant en salopette',
    category: 'crochet',
    tagline: 'Amigurumi crocheté main, 34 cm',
    description:
      "Grandes oreilles, longue trompe et salopette rouge amovible : cet éléphant est l'un des best-sellers de l'atelier. Chaque exemplaire est crocheté à la commande.",
    image:
      'https://cdn.magicpatterns.com/uploads/2UhC1cBe45pd2gHtbEL4cq/brk-298f3dd4-0d76-487e-aa9a-f32b99b0a1a2.jpg',
    price: 42,
    unit: 'la pièce',
    stock: 'sur-commande',
    featured: true,
    specs: [
      { label: 'Hauteur', value: 'Environ 34 cm' },
      { label: 'Matière', value: 'Fil acrylique doux' },
      { label: 'Délai', value: '8 à 10 jours de confection' },
      { label: 'Entretien', value: 'Lavage à la main, 30°' },
    ],
  },
  {
    slug: 'elephante-ballerine',
    name: 'Éléphante ballerine',
    category: 'crochet',
    tagline: 'Amigurumi crocheté main, 36 cm',
    description:
      "Sa robe à volants rose et ses oreilles doublées demandent un travail de finition minutieux. Une pièce cadeau, souvent choisie pour une naissance.",
    image:
      'https://cdn.magicpatterns.com/uploads/n7h9cBndaXSMMB3o5KegXY/brk-45136f91-6c06-4028-85c8-a5332d09583c.jpg',
    price: 45,
    unit: 'la pièce',
    stock: 'sur-commande',
    specs: [
      { label: 'Hauteur', value: 'Environ 36 cm' },
      { label: 'Matière', value: 'Fil acrylique doux' },
      { label: 'Délai', value: '8 à 10 jours de confection' },
      { label: 'Entretien', value: 'Lavage à la main, 30°' },
    ],
  },
  {
    slug: 'puzzle-personnalise',
    name: 'Puzzle personnalisé',
    category: 'puzzle',
    tagline: 'Votre visuel imprimé, de 500 à 1500 pièces',
    description:
      "Envoyez-nous votre photo ou choisissez un visuel du catalogue : nous imprimons et découpons votre puzzle, livré dans sa boîte. Trois formats au choix.",
    image:
      'https://cdn.magicpatterns.com/uploads/j7X1zQ5HqvbH94WfHpznRR/brk-884769dc-f32e-45cd-a56a-528dd629e4bc.jpg',
    price: 8,
    unit: 'la boîte',
    stock: 'en-stock',
    options: [
      { id: '500', label: '500 pièces', price: 8 },
      { id: '1000', label: '1000 pièces', price: 14 },
      { id: '1500', label: '1500 pièces', price: 18 },
    ],
    specs: [
      { label: 'Formats', value: '500 · 1000 · 1500 pièces' },
      { label: 'Impression', value: 'Visuel personnalisé ou catalogue' },
      { label: 'Livraison', value: 'Boîte cartonnée incluse' },
      { label: 'Délai', value: '5 jours ouvrés' },
    ],
  },
]

export function getProduct(slug: string): Product | undefined {
  return products.find((p) => p.slug === slug)
}
